import {required} from "vuelidate/lib/validators";  
const StrSorgular = {
    data() {
      return {  
        
        StrSorgularData: { 
          Sorgu: "",
          Sorguadi: "",
         // Aktif: false,
          Parametreler: "",
          Deleted: false,
          }, 
          FormDataType:{
            Sorguadi:{FieldName:"Sorguadi",Field:"input",FieldTitle:this.$t('StrSorgular.AddEdit.Sorguadi'),FieldType:"text"},
            Sorgu:{FieldName:"Sorgu",Field:"textarea",FieldTitle:this.$t('StrSorgular.AddEdit.Sorgu')},
            Parametreler:{FieldName:"Parametreler",Field:"input",FieldTitle:this.$t('StrSorgular.AddEdit.Parametreler'),FieldType:"text"}, 
           // Aktif:{FieldName:"Aktif",Field:"checkbox",FieldTitle:this.$t('StrSorgular.AddEdit.Aktif')}  
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Sorguadi: { required },  
        Sorgu: { required }, 
        Parametreler: {  }, 
       // Aktif: {  },  
      }
 
  },
}
export default StrSorgular